import React from "react"
import { Input, Table } from "reactstrap"
import AtelierRows from "./AtelierRows"
import FactoryRows from "./FactoryRows"
// import config from "config"
import SButton from "components/Common/Button"

export default function SizeTable(props) {
  const {
    sizes,
    type,
    config: {
      onSizeChange,
      onCompletedInspectChange,
      onReducedProdChange,
      onSubmit,
      orderDetailData: tableData,
      orderDetailData: {
        completedInspection: I,
        numberOfRemaining: R,
        reducedProduction: P,
        incompleteDeliveries: ID,
        numberOfDeliveries: D,
        sizes: S,
      },
    },
  } = props

  const getNumber = (type, number) => {
    const size = tableData.sizes.find(item => +item.size === number)

    if (!size) return ""

    return type === "unitPrice"
      ? Number(size[type]).toLocaleString("ja-JP")
      : size[type]
  }

  const getOrderSum = () => sizes.reduce((acc, item) => acc + item.orderQty, 0)
  const getPriceSum = () => sizes.reduce((acc, item) => acc + item.unitPrice, 0)

  const getMax = size => {
    const S = sizes.find(s => s.size === size)
    if (!S) return 0
    return S.orderQty
  }

  const getSum = key => key.reduce((acc, val) => acc + val, 0)
  const isDisabled = index => !S[index].orderQty

  return (
    <>
      <Table className="text-center" bordered>
        <thead>
          <tr>
            <td style={{ minWidth: 105 }}></td>
            <th className="text-start">order size assort</th>
            {/* <th className="text-start">単価</th> */}
            {type === "アトリエメイド" ? (
              <>
                <th>減産</th>
                <th>検品完了数（不良品数) </th>
                <td>残数</td>
              </>
            ) : (
              <>
                <td className="text-start">納品数</td>
                <td className="text-start">減産</td>
                <td className="text-start">検品完了数</td>
                <td className="text-start">納品未完了数</td>
              </>
            )}

            <th className="text-start">単価</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>42</td>
            <td>{getNumber("orderQty", 42)}</td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="42"
                    defaultValue={P[0]}
                    disabled={
                      isDisabled(0) ||
                      tableData.sizes[0].maxReducedProduction === 0
                    }
                    max={getMax("42")}
                    min={0}
                  />
                </td>
                <td>
                  {I[0] || 0}{" "}
                  {tableData.sizes[0].defect !== 0 &&
                    `(${tableData.sizes[0].defect})`}
                </td>

                <td>{R[0]}</td>
              </>
            ) : (
              <>
                <td>{D[0] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="42"
                    defaultValue={P[0]}
                    disabled={
                      tableData.sizes[0].unfinished === 0 ||
                      tableData.sizes[0].orderQty === 0
                    }
                    max={getMax("42")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="42"
                    defaultValue={I[0]}
                    disabled={
                      tableData.sizes[0].unfinished === 0 ||
                      tableData.sizes[0].orderQty === 0
                    }
                    max={getMax("42")}
                    min={0}
                  />
                </td>
                <td>{ID[0]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 42)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td>44</td>
            <td>{getNumber("orderQty", 44)}</td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="44"
                    defaultValue={P[1]}
                    value={P[1]}
                    disabled={
                      isDisabled(1) ||
                      tableData.sizes[1].maxReducedProduction === 0
                    }
                    max={getMax("44")}
                    min={0}
                  />
                </td>
                <td>
                  {I[1] || 0}{" "}
                  {tableData.sizes[1].defect !== 0 &&
                    `(${tableData.sizes[1].defect})`}
                </td>

                <td>{R[1]}</td>
              </>
            ) : (
              <>
                <td>{D[1] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="44"
                    defaultValue={P[1]}
                    disabled={
                      tableData.sizes[1].unfinished === 0 ||
                      tableData.sizes[1].orderQty === 0
                    }
                    max={getMax("44")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="44"
                    defaultValue={I[1] || 0}
                    disabled={
                      tableData.sizes[0].unfinished === 0 ||
                      tableData.sizes[0].orderQty === 0
                    }
                    max={getMax("44")}
                    min={0}
                  />
                </td>
                <td>{ID[1]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 44)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td>46</td>
            <td> {getNumber("orderQty", 46)} </td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="46"
                    defaultValue={P[2]}
                    disabled={
                      isDisabled(2) ||
                      tableData.sizes[2].maxReducedProduction === 0
                    }
                    max={getMax("46")}
                    min={0}
                  />
                </td>
                <td>
                  {I[2] || 0}{" "}
                  {tableData.sizes[2].defect !== 0 &&
                    `(${tableData.sizes[2].defect})`}
                </td>

                <td>{R[2]}</td>
              </>
            ) : (
              <>
                <td>{D[2] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="46"
                    defaultValue={P[2]}
                    disabled={
                      tableData.sizes[2].unfinished === 0 ||
                      tableData.sizes[2].orderQty === 0
                    }
                    max={getMax("46")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="46"
                    defaultValue={I[2] || 0}
                    disabled={
                      tableData.sizes[2].unfinished === 0 ||
                      tableData.sizes[2].orderQty === 0
                    }
                    max={getMax("46")}
                    min={0}
                  />
                </td>
                <td>{ID[2]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 48)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td>48</td>
            <td> {getNumber("orderQty", 48)} </td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="48"
                    defaultValue={P[3]}
                    disabled={
                      isDisabled(3) ||
                      tableData.sizes[3].maxReducedProduction === 0
                    }
                    max={getMax("48")}
                    min={0}
                  />
                </td>
                <td>
                  {I[3] || 0}{" "}
                  {tableData.sizes[3].defect !== 0 &&
                    `(${tableData.sizes[3].defect})`}
                </td>

                <td>{R[3]}</td>
              </>
            ) : (
              <>
                <td>{D[3] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="48"
                    defaultValue={P[3]}
                    disabled={
                      tableData.sizes[3].unfinished === 0 ||
                      tableData.sizes[3].orderQty === 0
                    }
                    max={getMax("48")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="48"
                    defaultValue={I[3] || 0}
                    disabled={
                      tableData.sizes[3].unfinished === 0 ||
                      tableData.sizes[3].orderQty === 0
                    }
                    max={getMax("48")}
                    min={0}
                  />
                </td>
                <td>{ID[3]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 48)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td>50</td>
            <td> {getNumber("orderQty", 50)} </td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="50"
                    defaultValue={P[4]}
                    disabled={
                      isDisabled(4) ||
                      tableData.sizes[4].maxReducedProduction === 0
                    }
                    max={getMax("50")}
                    min={0}
                  />
                </td>
                <td>
                  {I[4] || 0}{" "}
                  {tableData.sizes[4].defect !== 0 &&
                    `(${tableData.sizes[4].defect})`}
                </td>

                <td>{R[4]}</td>
              </>
            ) : (
              <>
                <td>{D[4] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="50"
                    defaultValue={P[4]}
                    disabled={
                      tableData.sizes[4].unfinished === 0 ||
                      tableData.sizes[4].orderQty === 0
                    }
                    max={getMax("50")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="50"
                    defaultValue={I[4] || 0}
                    disabled={
                      tableData.sizes[4].unfinished === 0 ||
                      tableData.sizes[4].orderQty === 0
                    }
                    max={getMax("50")}
                    min={0}
                  />
                </td>
                <td>{ID[4]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 50)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td>52</td>
            <td> {getNumber("orderQty", 52)} </td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="52"
                    defaultValue={P[5]}
                    disabled={
                      isDisabled(5) ||
                      tableData.sizes[5].maxReducedProduction === 0
                    }
                    max={getMax("52")}
                    min={0}
                  />
                </td>

                <td>
                  {I[5] || 0}{" "}
                  {tableData.sizes[5].defect !== 0 &&
                    `(${tableData.sizes[5].defect})`}
                </td>

                <td>{R[5]}</td>
              </>
            ) : (
              <>
                <td>{D[5] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="52"
                    defaultValue={P[5]}
                    disabled={
                      tableData.sizes[5].unfinished === 0 ||
                      tableData.sizes[5].orderQty === 0
                    }
                    max={getMax("52")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="52"
                    defaultValue={I[5] || 0}
                    disabled={
                      tableData.sizes[5].unfinished === 0 ||
                      tableData.sizes[5].orderQty === 0
                    }
                    max={getMax("52")}
                    min={0}
                  />
                </td>
                <td>{ID[5]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 52)} readOnly disabled />
            </td>
          </tr>

          <tr>
            <td>54</td>
            <td> {getNumber("orderQty", 54)} </td>
            {type === "アトリエメイド" ? (
              <>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="54"
                    defaultValue={P[6]}
                    disabled={
                      isDisabled(6) ||
                      tableData.sizes[6].maxReducedProduction === 0
                    }
                    max={getMax("54")}
                    min={0}
                  />
                </td>
                <td>
                  {I[6] || 0}{" "}
                  {tableData.sizes[6].defect !== 0 &&
                    `(${tableData.sizes[6].defect})`}
                </td>

                <td>{R[6]}</td>
              </>
            ) : (
              <>
                <td>{D[6] || 0}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    onChange={onReducedProdChange}
                    data-size="54"
                    defaultValue={P[6]}
                    disabled={
                      tableData.sizes[6].unfinished === 0 ||
                      tableData.sizes[6].orderQty === 0
                    }
                    max={getMax("54")}
                    min={0}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    onChange={onCompletedInspectChange}
                    className="form-control"
                    data-size="54"
                    defaultValue={I[6] || 0}
                    disabled={
                      tableData.sizes[6].unfinished === 0 ||
                      tableData.sizes[6].orderQty === 0
                    }
                    max={getMax("54")}
                    min={0}
                  />
                </td>
                <td>{ID[6]}</td>
              </>
            )}
            <td>
              <Input value={getNumber("unitPrice", 54)} readOnly disabled />
            </td>
          </tr>
          <tr>
            <td style={{ minWidth: 105 }}>合計</td>
            <td>{getOrderSum()}</td>
            {type === "アトリエメイド" ? (
              <>
                <td>{getSum(P)}</td>
                <td>{getSum(I)}</td>
                <td>{getSum(R)}</td>
              </>
            ) : (
              <>
                <td>{getSum(D)}</td>
                <td>{getSum(P)}</td>
                <td>
                  <SButton onClick={() => onSubmit(false)}>保存</SButton>
                </td>
                <td>{getSum(ID)}</td>
              </>
            )}

            <td>{getPriceSum().toLocaleString("ja-JP")}</td>
          </tr>

          {/* {type === "アトリエメイド" ? (
            // アトリエメイド
            // <p>atelier</p>
            <AtelierRows
              onReducedProdChange={onReducedProdChange}
              onCompletedInspectChange={onCompletedInspectChange}
              sizes={sizes}
              config={props.config}
            />
          ) : (
            <FactoryRows
              onReducedProdChange={onReducedProdChange}
              onCompletedInspectChange={onCompletedInspectChange}
              sizes={sizes}
              onSubmit={onSubmit}
              config={props.config}
            />
            // <p>Factory</p>
          )} */}
          {/* last row, used by both */}
        </tbody>
      </Table>
    </>
  )
}
